// extracted by mini-css-extract-plugin
export default {"add-programs-header":"CreateNewsHeader_add-programs-header__73nim","title":"CreateNewsHeader_title__uEGjy","icon-subcontainer":"CreateNewsHeader_icon-subcontainer__4A52a"};